<script src="./index.js"></script>
<style src="./style.scss" lang="scss" scoped/>
<template>
  <div class="label-discount">
    -{{ amount }}%
  </div>
</template>

